import { useState } from "react";
import { ChevronLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";
import Password from "./Password";
import Profile from "./Profile";
import { useThemeClass } from "@/Hooks/useThemeClass";
import { useTheme } from "styled-components";
import clsx from "clsx";

function UpdateProfile() {
  const themeClass = useThemeClass();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <div className="px-3">
      {/* Header */}
      <div className={` ${clsx(themeClass.text("text"), themeClass.border("text"))} flex justify-between items-center py-3 border-b `}>
        <Link to="/mypage">
          <ChevronLeft />
        </Link>
        <p className="text-[18px] font-bold">정보수정</p>
        <Link to="/" className="flex text-[12px] items-center text-center">
          <Home />
        </Link>
      </div>

      {/* Tabs */}
      <div className="pt-7 border-b flex gap-2 text-sm">
        <p
          className={`px-4 py-2 font-bold cursor-pointer ${
            activeTab === "profile"
              ? `${clsx(themeClass.text("text"), themeClass.border("text"))} border-b-2`
              : "text-gray-600"
          }`}
          onClick={() => setActiveTab("profile")}
        >
          기본정보
        </p>
        <p
          className={`px-4 py-2 cursor-pointer ${
            activeTab === "password"
              ? `${clsx(themeClass.text("text"), themeClass.border("text"))} border-b-2`
              : "text-gray-600"
          }`}
          onClick={() => setActiveTab("password")}
        >
          비밀번호 재설정
        </p>
      </div>

      {/* Content */}
      <div className="pt-4">
        {activeTab === "profile" && <Profile />}
        {activeTab === "password" && <Password />}
      </div>
    </div>
  );
}

export default UpdateProfile;
